(function()
{
	// Include the parent class
	var Application = include('springroll.Application');
	var Container = include('PIXI.Container');
	var Debug = include('springroll.Debug', false);
	var ScaleManager = include('springroll.ScaleManager');
	var State = include('springroll.State');

	// Create a new state for the title section of the game
	var TitleState = function(options)
	{
		State.call(this, new nature.TitlePanel(), options);

		this.onAssetsLoaded = this.onAssetsLoaded.bind(this);
		this.nextState = this.nextState.bind(this);
		this.on('loaded', this.onAssetsLoaded);
	};

	var s = State.prototype;
	// Inherit the prototype chain from State
	var p = extend(TitleState, State);

	p.onAssetsLoaded = function()
	{
		var panel = this.panel;
		panel.setup();
		panel.background.on('tap', this.nextState);
		panel.background.on('click', this.nextState);
		panel.playButton.on('buttonPress', this.nextState);
	};

	p.exitStart = function()
	{
		var panel = this.panel;
		panel.background.off('tap', this.nextState);
		panel.background.off('click', this.nextState);
		panel.playButton.off('buttonPress', this.nextState);
	};

	p.exit = function()
	{
		this.panel.teardown();

		s.exit.call(this);
	};

	namespace('nature').TitleState = TitleState;
}());
